import { Action, createReducer, on } from '@ngrx/store';
import { initialState, UserState } from './state';
import { getAllUsers, getAllUsersFailure, getAllUsersSuccess } from './actions';

const reducer = createReducer(
  initialState,
  on(getAllUsers, (state, { data }) => ({
    ...state,
    list: [],
  })),

  on(getAllUsersSuccess, (state, { data }) => ({
    ...state,
    list: data.result,
  })),

  on(getAllUsersFailure, (state, { error }) => ({
    ...state,
    list: [],
  })),
);

export function UserReducer(state: UserState, action: Action) {
  return reducer(state, action);
}
